<template>
  <div class="interval-form-menu"  id="dashboard">
    <p>DRO/DRI</p>

    <div
        :class="{'bg-info' : isIntervalStarted, 'bg-warning' : !isIntervalStarted && !isIntervalCompleted, 'bg-success': isIntervalCompleted}">


      <mdc-button type="submit"
                  class="button-transparent text-uppercase left-button"
                  @click="finishSession()"
                  @keyup.32="clickPrevent"
                  v-if="isIntervalStarted">
        <img src="../../../assets/images/round-timer_off-24px.svg"
             :alt="'dro.finish_session' | trans">
      </mdc-button>
      <mdc-button type="submit"
                  class="button-transparent text-uppercase left-button"
                  @click="saveSession()"
                  @keyup.32="clickPrevent"
                  v-if="!isIntervalStarted">
        <img src="../../../assets/images/round-timer_off-24px.svg"
             :alt="'dro.finish_session' | trans">
      </mdc-button>

      <interval-progress-bar></interval-progress-bar>

      <mdc-button type="submit"
                  class="button-transparent text-uppercase right-button"
                  @click="onBehaviourHappened()"
                  @keyup.32="clickPrevent"
                  v-if="isIntervalStarted">
        <img src="../../../assets/images/round-session.svg"
             :alt="'dro.target_behaviour' | trans">
      </mdc-button>
      <mdc-button type="submit"
                  class="button-transparent text-uppercase right-button"
                  @click="startSession()"
                  @keyup.32="clickPrevent"
                  v-if="!isIntervalStarted">
        <img src="../../../assets/images/round-restore-24px.svg"
             :alt="'dro.continue_session' | trans">
      </mdc-button>

    </div>
  </div>
</template>

<script>
  import debounce from 'lodash/debounce';
  import {currentIntervalForm} from '../../../mixins/currentIntervalForm';

  export default {

    mixins: [currentIntervalForm],
    data() {
      return {
        scrollY: 0,
      };
    },
    computed: {
      isIntervalCompleted: function() {
        let interval = this.currentInterval;
        return (interval.current == interval.duration);
      },
    },
    methods: {
      clickPrevent (e) {
        e.preventDefault();
      },
      handleIntervalScroll() {
        if (window.scrollY < 60) {
          this.scrollY = window.scrollY;
        } else {
          this.scrollY = 60;
        }
      },
    },
    created() {
      this.fillFormData();
      this.init();
      if (this.isMobile) {
        window.addEventListener('scroll', debounce(() => {
          this.handleIntervalScroll();
        }, 0.1));
      }
    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/dro/components/CurrentIntervalFormMenu.vue